module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['header-wrapper', {
      scrolled: _vm.st
    }]
  }, [_c('div', [_c('header', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "w-box"
  }, [_c('div', {
    staticClass: "nav-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/login",
      "title": "医小智-牙嗖嗖"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "menu-box"
  }, [_c('div', {
    class: _vm.user.isLogin == true ? 'nav-list-login' : 'nav-list'
  }, _vm._l((_vm.navList), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "nav-item-dropdown"
    }, [_c('a', {
      class: {
        active: _vm.common.navSelect.navIndex === i
      },
      on: {
        "click": function($event) {
          return _vm.changeNav(i, item)
        }
      }
    }, [_vm._v(_vm._s(item.navLabel))]), _vm._v(" "), (item.navSubList && item.navSubList.length > 1) ? _c('ul', {
      staticClass: "nav-dropdown"
    }, _vm._l((item.navSubList), function(sub, j) {
      return _c('li', {
        key: j,
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeSubNav(j, sub)
          }
        }
      }, [_c('a', {
        class: {
          active: _vm.common.navSelect.navIndex === i && _vm.common.navSelect.navSubIndex === j
        }
      }, [_vm._v(_vm._s(sub.navLabel))])])
    }), 0) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-box"
  }, [(!_vm.user.isLogin) ? _c('div', {
    staticClass: "nav-login-btn",
    on: {
      "click": _vm.toLogin
    }
  }, [_c('svg', {
    staticClass: "login-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "16",
      "height": "16",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
    }
  })]), _vm._v("\n            登录\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "aside",
    staticClass: "nav-aside",
    style: (_vm.user.isLogin == true ? 'opacity:1;' : 'opacity:0;')
  }, [(_vm.user.isLogin) ? _c('div', {
    staticClass: "user pr"
  }, [_c('div', {
    staticClass: "user-name-trigger"
  }, [_c('span', {
    staticClass: "user-avatar-small",
    style: (_vm.user.avatar ? 'background-image:url(' + _vm.user.avatar + ')' : 'background-image:url(/static/images/default.png)')
  }), _vm._v(" "), _c('span', {
    staticClass: "user-name-text"
  }, [_vm._v(_vm._s(_vm.user.contact || _vm.user.nickName || _vm.user.loginName))]), _vm._v(" "), _c('i', {
    staticClass: "arrow-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-user-wrapper pa"
  }, [_c('div', {
    staticClass: "nav-user-list"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/user/information"
    }
  }, [_vm._v("基本信息")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/addressList"
    }
  }, [_vm._v("收货地址")])], 1), _vm._v(" "), (_vm.user.userType !== '20') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/inviteDesigner"
    }
  }, [_vm._v("邀约设计师")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.userType !== '20') ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/blockDesList"
    }
  }, [_vm._v("拉黑设计师")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/user/support"
    }
  }, [_vm._v("售后服务")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.clickLogout
    }
  }, [_vm._v("退出账号")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "600px",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "header-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticStyle: {
      "padding": "15px 20px"
    }
  }, [_vm._v("认证申请")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-around",
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "item itme1"
  }, [_c('a', {
    on: {
      "click": _vm.factory
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("诊所/工厂认证")])])]), _vm._v(" "), _c('div', {
    staticClass: "item itme2"
  }, [_c('a', {
    on: {
      "click": _vm.designer
    }
  }, [_c('div', {
    staticClass: "t fiex f-18"
  }, [_c('div', {
    staticClass: "t2 center"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/zc22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("设计师认证")])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.logoutDialogVisible,
      "width": "400px",
      "center": "",
      "modal": false,
      "custom-class": "logout-confirm-dialog"
    },
    on: {
      "update:visible": function($event) {
        _vm.logoutDialogVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "color": "#333",
      "padding": "10px 0"
    }
  }, [_vm._v("确定要退出账号吗？")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.logoutDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.confirmLogout
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4f8e0ae","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/MHeader.vue
// module id = 691
// module chunks = 0